<template>
  <section class="container">
    <div class="consumer-audio">
      <div class="consumer-audio__heading">
        <Title>
          Código de defesa do consumidor em áudio
        </Title>
        <p>Escute o código de defesa do consumidor de onde você estiver.</p>
      </div>
      <div class="consumer-audio__content">
        <Audio
          :paragraphs="paragraphs"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/common/Title.vue';
import Audio from '@/components/consumerDefenseComponents/Audio.vue';

export default {
  name: 'DefenseCodeAudio',

  components: {
    Title,
    Audio,
  },

  data() {
    return {
      paragraphs: [
        {
          mainTitle: 'TÍTULO I',
          mainSubtitle: 'Dos Direitos do Consumidor',
          title: 'Capítulo I',
          subtitle: 'Das disposições gerais',
          articles: [
          {
            id: 'cap1art1',
            title: 'Art. 1º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20001.mp3',
          },
          {
            id: 'cap1art2',
            title: 'Art. 2º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20002.mp3',
          },
          {
            id: 'cap1art3',
            title: 'Art. 3º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20003.mp3',
          },
          ],
        },
        {
          title: 'Capítulo II',
          subtitle: 'Da Política Nacional de Relações de Consumo',
          articles: [
          {
            id: 'cap2art4',
            title: 'Art. 4º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20004.mp3',
          },
          {
            id: 'cap2art5',
            title: 'Art. 5º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20005.mp3',
          }
          ]
        },
        {
          title: 'Capítulo III',
          subtitle: 'Dos Direitos Básicos do Consumidor',
          articles: [
          {
            id: 'cap3art6',
            title: 'Art. 6º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20006.mp3',
          },
          {
            id: 'cap3art7',
            title: 'Art. 7º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20007.mp3',
          }
          ]
        },
        {
          title: 'Capítulo IV',
          subtitle: 'Da Qualidade de Produtos e Serviços, da Prevenção e da Reparação dos Danos',
          articles: [
          {
            id: 'cap4art8',
            title: 'Art. 8º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20008.mp3',
          },
          {
            id: 'cap4art9',
            title: 'Art. 9º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20009.mp3',
          },
          {
            id: 'cap4art10',
            title: 'Art. 10º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20010.mp3',
          },
          {
            id: 'cap4art11',
            title: 'Art. 11º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20011.mp3',
          },
          {
            id: 'cap4art12',
            title: 'Art. 12º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20012.mp3',
          },
          {
            id: 'cap4art13',
            title: 'Art. 13º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20013.mp3',
          },
          {
            id: 'cap4art14',
            title: 'Art. 14º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20014.mp3',
          },
          {
            id: 'cap4art15',
            title: 'Art. 15º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20015.mp3',
          },
          {
            id: 'cap4art16',
            title: 'Art. 16º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20016.mp3',
          },
          {
            id: 'cap4art17',
            title: 'Art. 17º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20017.mp3',
          },
          {
            id: 'cap4art18',
            title: 'Art. 18º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20018.mp3',
          },
          {
            id: 'cap4art19',
            title: 'Art. 19º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20019.mp3',
          },
          {
            id: 'cap4art20',
            title: 'Art. 20º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20020.mp3',
          },
          {
            id: 'cap4art21',
            title: 'Art. 21º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20021.mp3',
          },
          {
            id: 'cap4art22',
            title: 'Art. 22º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20022.mp3',
          },
          {
            id: 'cap4art23',
            title: 'Art. 23º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20023.mp3',
          },
          {
            id: 'cap4art24',
            title: 'Art. 24º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20024.mp3',
          },
          {
            id: 'cap4art25',
            title: 'Art. 25º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20025.mp3',
          },
          {
            id: 'cap4art26',
            title: 'Art. 26º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20026.mp3',
          },
          {
            id: 'cap4art27',
            title: 'Art. 27º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20027.mp3',
          },
          {
            id: 'cap4art28',
            title: 'Art. 28º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20028.mp3',
          },
          ]
        },
        {
          title: 'Capítulo V',
          subtitle: 'Das Práticas Comerciais',
          articles: [
          {
            id: 'cap5art29',
            title: 'Art. 29º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20029.mp3',
          },
          {
            id: 'cap5art30',
            title: 'Art. 30º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20030.mp3',
          },
          {
            id: 'cap5art31',
            title: 'Art. 31º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20031.mp3',
          },
          {
            id: 'cap5art32',
            title: 'Art. 32º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20032.mp3',
          },
          {
            id: 'cap5art33',
            title: 'Art. 33º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20033.mp3',
          },
          {
            id: 'cap5art34',
            title: 'Art. 34º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20034.mp3',
          },
          {
            id: 'cap5art35',
            title: 'Art. 35º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20035.mp3',
          },
          {
            id: 'cap5art36',
            title: 'Art. 36º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20036.mp3',
          },
          {
            id: 'cap5art37',
            title: 'Art. 37º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20037.mp3',
          },
          {
            id: 'cap5art38',
            title: 'Art. 38º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20038.mp3',
          },
          {
            id: 'cap5art39',
            title: 'Art. 39º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20039.mp3',
          },
          {
            id: 'cap5art40',
            title: 'Art. 40º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20040.mp3',
          },
          {
            id: 'cap5art41',
            title: 'Art. 41º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20041.mp3',
          },
          {
            id: 'cap5art42',
            title: 'Art. 42º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20042.mp3',
          },
          {
            id: 'cap5art42a',
            title: 'Art. 42-Aº',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20042%20A.mp3',
          },
          {
            id: 'cap5art43',
            title: 'Art. 43º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20043.mp3',
          },
          {
            id: 'cap5art44',
            title: 'Art. 44º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20044.mp3',
          },
          {
            id: 'cap5art45',
            title: 'Art. 45º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20045.mp3',
          },
          ]
        },
        {
          title: 'Capítulo VI',
          subtitle: 'Da Proteção Contratual',
          articles: [
          {
            id: 'cap6art46',
            title: 'Art. 46º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20046.mp3',
          },
          {
            id: 'cap6art47',
            title: 'Art. 47º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20047.mp3',
          },
          {
            id: 'cap6art48',
            title: 'Art. 48º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20048.mp3',
          },
          {
            id: 'cap6art49',
            title: 'Art. 49º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20049.mp3',
          },
          {
            id: 'cap6art50',
            title: 'Art. 50º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20050.mp3',
          },
          {
            id: 'cap6art51',
            title: 'Art. 51º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20051.mp3',
          },
          {
            id: 'cap6art52',
            title: 'Art. 52º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20052.mp3',
          },
          {
            id: 'cap6art53',
            title: 'Art. 53º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20053.mp3',
          },
          {
            id: 'cap6art54',
            title: 'Art. 54º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20054.mp3',
          },
          ]
        },
        {
          title: 'Capítulo VII',
          subtitle: 'Das Sanções Administrativas',
          articles: [
          {
            id: 'cap7art55',
            title: 'Art. 55º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20055.mp3',
          },
          {
            id: 'cap7art56',
            title: 'Art. 56º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20056.mp3',
          },
          {
            id: 'cap7art57',
            title: 'Art. 57º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20057.mp3',
          },
          {
            id: 'cap7art58',
            title: 'Art. 58º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20058.mp3',
          },
          {
            id: 'cap7art59',
            title: 'Art. 59º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20059.mp3',
          },
          {
            id: 'cap7art60',
            title: 'Art. 60º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20060.mp3',
          },
          ]
        },
        {
          mainTitle: 'Título II',
          mainSubtitle: 'Das Infrações Penais',
          articles: [
          {
            id: 'cap7art61',
            title: 'Art. 61º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20061.mp3',
          },
          {
            id: 'cap7art62',
            title: 'Art. 62º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20062.mp3',
          },
          {
            id: 'cap7art63',
            title: 'Art. 63º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20063.mp3',
          },
          {
            id: 'cap7art64',
            title: 'Art. 64º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20064.mp3',
          },
          {
            id: 'cap7art65',
            title: 'Art. 65º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20065.mp3',
          },
          {
            id: 'cap7art66',
            title: 'Art. 66º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20066.mp3',
          },
          {
            id: 'cap7art67',
            title: 'Art. 67º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20067.mp3',
          },
          {
            id: 'cap7art68',
            title: 'Art. 68º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20068.mp3',
          },
          {
            id: 'cap7art69',
            title: 'Art. 69º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20069.mp3',
          },
          {
            id: 'cap7art70',
            title: 'Art. 70º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20070.mp3',
          },
          {
            id: 'cap7art71',
            title: 'Art. 71º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20071.mp3',
          },
          {
            id: 'cap5art72',
            title: 'Art. 72º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20072.mp3',
          },
          {
            id: 'cap5art73',
            title: 'Art. 73º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20073.mp3',
          },
          {
            id: 'cap5art74',
            title: 'Art. 74º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20074.mp3',
          },
          {
            id: 'cap5art75',
            title: 'Art. 75º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20075.mp3',
          },
          {
            id: 'cap5art76',
            title: 'Art. 76º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20076.mp3',
          },
          {
            id: 'cap5art77',
            title: 'Art. 77º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20077.mp3',
          },
          {
            id: 'cap5art78',
            title: 'Art. 78º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20078.mp3',
          },
          {
            id: 'cap5art79',
            title: 'Art. 79º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20079.mp3',
          },
          {
            id: 'cap5art80',
            title: 'Art. 80º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20080.mp3',
          },
          ]
        },
        {
          mainTitle: 'TÍTULO III',
          mainSubtitle: 'Da Defesa do Consumidor em Juízo',
          title: 'Capítulo I',
          subtitle: 'Disposições gerais',
          articles: [
          {
            id: 'cap1art81',
            title: 'Art. 81º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20081.mp3',
          },
          {
            id: 'cap1art82',
            title: 'Art. 82º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20082.mp3',
          },
          {
            id: 'cap1art83',
            title: 'Art. 83º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20083.mp3',
          },
          {
            id: 'cap1art84',
            title: 'Art. 84º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20084.mp3',
          },
          {
            id: 'cap1art85',
            title: 'Art. 85º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20085.mp3',
          },
          {
            id: 'cap1art86',
            title: 'Art. 86º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20086.mp3',
          },
          {
            id: 'cap1art87',
            title: 'Art. 87º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20087.mp3',
          },
          {
            id: 'cap1art88',
            title: 'Art. 88º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20088.mp3',
          },
          {
            id: 'cap1art89',
            title: 'Art. 89º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20089.mp3',
          },
          {
            id: 'cap1art90',
            title: 'Art. 90º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20090.mp3',
          },
          ],
        },
        {
          title: 'Capítulo II',
          subtitle: 'Das Ações Coletivas Para a Defesa de Interesses Individuais Homogêneos',
          articles: [
          {
            id: 'cap2art91',
            title: 'Art. 91º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20091.mp3',
          },
          {
            id: 'cap2art92',
            title: 'Art. 92º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20092.mp3',
          },
          {
            id: 'cap2art93',
            title: 'Art. 93º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20093.mp3',
          },
          {
            id: 'cap2art94',
            title: 'Art. 94º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20094.mp3',
          },
          {
            id: 'cap2art95',
            title: 'Art. 95º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20095.mp3',
          },
          {
            id: 'cap2art96',
            title: 'Art. 96º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20096.mp3',
          },
          {
            id: 'cap2art97',
            title: 'Art. 97º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20097.mp3',
          },
          {
            id: 'cap2art98',
            title: 'Art. 98º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20098.mp3',
          },
          {
            id: 'cap2art99',
            title: 'Art. 99º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20099.mp3',
          },
          {
            id: 'cap2art100',
            title: 'Art. 100º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20100.mp3',
          },
          ],
        },
        {
          title: 'Capítulo III',
          subtitle: 'Das Ações de Responsabilidade do Fornecedor de Produtos e Serviços',
          articles: [
          {
            id: 'cap3art101',
            title: 'Art. 101º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20101.mp3',
          },
          {
            id: 'cap3art102',
            title: 'Art. 102º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20102.mp3',
          },
          ],
        },
        {
          title: 'Capítulo IV',
          subtitle: 'Da Coisa Julgada',
          articles: [
          {
            id: 'cap4art103',
            title: 'Art. 103º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20103.mp3',
          },
          {
            id: 'cap4art104',
            title: 'Art. 104º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20104.mp3',
          },
          ],
        },
        {
          mainTitle: 'TÍTULO IV',
          mainSubtitle: 'Do Sistema Nacional de Defesa do Consumidor',
          title: 'Capítulo V',
          subtitle: 'Da Conciliação No Superendividamento',
          articles: [
          {
            id: 'cap5art105',
            title: 'Art. 105º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20105.mp3',
          },
          {
            id: 'cap5art106',
            title: 'Art. 106º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20106.mp3',
          },
          ],
        },
        {
          mainTitle: 'TÍTULO V',
          mainSubtitle: 'Da Convenção Coletiva de Consumo',
          articles: [
          {
            id: 'cap5art107',
            title: 'Art. 107º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20107.mp3',
          },
          {
            id: 'cap5art108',
            title: 'Art. 108º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20108.mp3',
          },
          ],
        },
        {
          mainTitle: 'TÍTULO VI',
          mainSubtitle: 'Disposições Finais',
          articles: [
          {
            id: 'cap5art109',
            title: 'Art. 109º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20109.mp3',
          },
          {
            id: 'cap5art110',
            title: 'Art. 110º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20110.mp3',
          },
          {
            id: 'cap5art111',
            title: 'Art. 111º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20111.mp3',
          },
          {
            id: 'cap5art112',
            title: 'Art. 112º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20112.mp3',
          },
          {
            id: 'cap5art113',
            title: 'Art. 113º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20113.mp3',
          },
          {
            id: 'cap5art114',
            title: 'Art. 114º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20114.mp3',
          },
          {
            id: 'cap5art115',
            title: 'Art. 115º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20115.mp3',
          },
          {
            id: 'cap5art116',
            title: 'Art. 116º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20116.mp3',
          },
          {
            id: 'cap5art117',
            title: 'Art. 117º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20117.mp3',
          },
          {
            id: 'cap5art118',
            title: 'Art. 118º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20118.mp3',
          },
          {
            id: 'cap5art119',
            title: 'Art. 119º',
            src: 'https://file-cdc-audios.uppersoft.com.br/cdcaudios/Art%20119.mp3',
          },
          ],
        },
      ],
    };
  },

  metaInfo() {
    return {
      title: 'Código de defesa do consumidor em Audio',
    };
  },

};
</script>
